/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Api
 * My ATS API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AIProviderChain,
  AIProviderChainInput,
  AiTaskAccepted,
  AiTaskDetail,
  AiTaskListResponse,
  AiTaskViewedResponse,
  Analysis,
  AnalysisInput,
  AnalysisTicketHistoryPage,
  AnalysisTicketRewardInput,
  AnalysisTicketRewardResult,
  AnalysisTicketSummary,
  AnswersInput,
  AuthUser,
  Company,
  CompanyInput,
  CompanyPostingDetailInput,
  CompanyPostingDetailResponse,
  CompanyPostingNextInput,
  CompanyPostingNextResponse,
  CompanyPostingSaveInput,
  CompanyPostingSaveResponse,
  CompanyPostingSearchInput,
  CompanyPostingSearchResponse,
  CompanyRecommendationTaskInput,
  CompanySearchErrorResponse,
  CompanyUpdate,
  CoverLetterAudioInput,
  CoverLetterGenerationResult,
  DashboardSummary,
  ErrorResponse,
  FetchPostingsInput,
  GetAnalysisTicketHistoryParams,
  GuidedPromptsInput,
  GuidedPromptsResult,
  HealthStatus,
  InterviewInput,
  InterviewSession,
  JobPosting,
  JobPostingImportTaskInput,
  JobPostingSearchTaskInput,
  ListAiTasksParams,
  ListNotificationsParams,
  LoginInput,
  MessageResponse,
  NotificationListResponse,
  NotificationReadAllResponse,
  NotificationReadResponse,
  RecommendInput,
  RegisterInput,
  Resume,
  ResumeInput,
  ResumeUpdate,
  ResumeUploadTaskInput,
  SpellcheckInput,
  SpellcheckResult,
  SubscribeInput,
  SubscriptionPlan,
  ToastClaimsInput,
  ToastClaimsResponse,
  TossLoginInput,
  TossLoginResponse,
  UserSubscription
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetAIProviderChainUrl = () => {




  return `/api/admin/settings/ai/providers`
}

/**
 * @summary Get masked AI fallback provider configuration
 */
export const getAIProviderChain = async ( options?: RequestInit): Promise<AIProviderChain> => {

  return customFetch<AIProviderChain>(getGetAIProviderChainUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAIProviderChainQueryKey = () => {
    return [
    `/api/admin/settings/ai/providers`
    ] as const;
    }


export const getGetAIProviderChainQueryOptions = <TData = Awaited<ReturnType<typeof getAIProviderChain>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAIProviderChain>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAIProviderChainQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAIProviderChain>>> = ({ signal }) => getAIProviderChain({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAIProviderChain>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAIProviderChainQueryResult = NonNullable<Awaited<ReturnType<typeof getAIProviderChain>>>
export type GetAIProviderChainQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get masked AI fallback provider configuration
 */

export function useGetAIProviderChain<TData = Awaited<ReturnType<typeof getAIProviderChain>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAIProviderChain>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAIProviderChainQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAIProviderChainSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAIProviderChain>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAIProviderChain>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAIProviderChainQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAIProviderChain>>> = ({ signal }) => getAIProviderChain({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAIProviderChain>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAIProviderChainSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAIProviderChain>>>
export type GetAIProviderChainSuspenseQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get masked AI fallback provider configuration
 */

export function useGetAIProviderChainSuspense<TData = Awaited<ReturnType<typeof getAIProviderChain>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAIProviderChain>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAIProviderChainSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAIProviderChainUrl = () => {




  return `/api/admin/settings/ai/providers`
}

/**
 * @summary Atomically replace provider keys and enable or disable fallback chain
 */
export const updateAIProviderChain = async (aIProviderChainInput: AIProviderChainInput, options?: RequestInit): Promise<AIProviderChain> => {

  return customFetch<AIProviderChain>(getUpdateAIProviderChainUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(aIProviderChainInput)
  }
);}





export const getUpdateAIProviderChainMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAIProviderChain>>, TError,{data: BodyType<AIProviderChainInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAIProviderChain>>, TError,{data: BodyType<AIProviderChainInput>}, TContext> => {

const mutationKey = ['updateAIProviderChain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAIProviderChain>>, {data: BodyType<AIProviderChainInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateAIProviderChain(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAIProviderChainMutationResult = NonNullable<Awaited<ReturnType<typeof updateAIProviderChain>>>
    export type UpdateAIProviderChainMutationBody = BodyType<AIProviderChainInput>
    export type UpdateAIProviderChainMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Atomically replace provider keys and enable or disable fallback chain
 */
export const useUpdateAIProviderChain = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAIProviderChain>>, TError,{data: BodyType<AIProviderChainInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAIProviderChain>>,
        TError,
        {data: BodyType<AIProviderChainInput>},
        TContext
      > => {
      return useMutation(getUpdateAIProviderChainMutationOptions(options));
    }

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRegisterUrl = () => {




  return `/api/auth/register`
}

/**
 * @summary Register a new user
 */
export const register = async (registerInput: RegisterInput, options?: RequestInit): Promise<AuthUser> => {

  return customFetch<AuthUser>(getRegisterUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registerInput)
  }
);}





export const getRegisterMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: BodyType<RegisterInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: BodyType<RegisterInput>}, TContext> => {

const mutationKey = ['register'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof register>>, {data: BodyType<RegisterInput>}> = (props) => {
          const {data} = props ?? {};

          return  register(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterMutationResult = NonNullable<Awaited<ReturnType<typeof register>>>
    export type RegisterMutationBody = BodyType<RegisterInput>
    export type RegisterMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Register a new user
 */
export const useRegister = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: BodyType<RegisterInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof register>>,
        TError,
        {data: BodyType<RegisterInput>},
        TContext
      > => {
      return useMutation(getRegisterMutationOptions(options));
    }

export const getLoginUrl = () => {




  return `/api/auth/login`
}

/**
 * @summary Login with email and password
 */
export const login = async (loginInput: LoginInput, options?: RequestInit): Promise<AuthUser> => {

  return customFetch<AuthUser>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginInput)
  }
);}





export const getLoginMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<LoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<LoginInput>}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: BodyType<LoginInput>}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = BodyType<LoginInput>
    export type LoginMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Login with email and password
 */
export const useLogin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<LoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: BodyType<LoginInput>},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options));
    }

export const getLoginWithTossUrl = () => {




  return `/api/auth/toss/login`
}

/**
 * @summary Exchange a Toss authorization code for an application session
 */
export const loginWithToss = async (tossLoginInput: TossLoginInput, options?: RequestInit): Promise<TossLoginResponse> => {

  return customFetch<TossLoginResponse>(getLoginWithTossUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tossLoginInput)
  }
);}





export const getLoginWithTossMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWithToss>>, TError,{data: BodyType<TossLoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof loginWithToss>>, TError,{data: BodyType<TossLoginInput>}, TContext> => {

const mutationKey = ['loginWithToss'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginWithToss>>, {data: BodyType<TossLoginInput>}> = (props) => {
          const {data} = props ?? {};

          return  loginWithToss(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginWithTossMutationResult = NonNullable<Awaited<ReturnType<typeof loginWithToss>>>
    export type LoginWithTossMutationBody = BodyType<TossLoginInput>
    export type LoginWithTossMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Exchange a Toss authorization code for an application session
 */
export const useLoginWithToss = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWithToss>>, TError,{data: BodyType<TossLoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof loginWithToss>>,
        TError,
        {data: BodyType<TossLoginInput>},
        TContext
      > => {
      return useMutation(getLoginWithTossMutationOptions(options));
    }

export const getLogoutUrl = () => {




  return `/api/auth/logout`
}

/**
 * @summary Logout current user
 */
export const logout = async ( options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = ErrorType<unknown>

    /**
 * @summary Logout current user
 */
export const useLogout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options));
    }

export const getGetMeUrl = () => {




  return `/api/auth/me`
}

/**
 * @summary Get current user
 */
export const getMe = async ( options?: RequestInit): Promise<AuthUser> => {

  return customFetch<AuthUser>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get current user
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSubscriptionPlansUrl = () => {




  return `/api/subscription/plans`
}

/**
 * @summary List available subscription plans
 */
export const listSubscriptionPlans = async ( options?: RequestInit): Promise<SubscriptionPlan[]> => {

  return customFetch<SubscriptionPlan[]>(getListSubscriptionPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSubscriptionPlansQueryKey = () => {
    return [
    `/api/subscription/plans`
    ] as const;
    }


export const getListSubscriptionPlansQueryOptions = <TData = Awaited<ReturnType<typeof listSubscriptionPlans>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionPlans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSubscriptionPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSubscriptionPlans>>> = ({ signal }) => listSubscriptionPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionPlans>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSubscriptionPlansQueryResult = NonNullable<Awaited<ReturnType<typeof listSubscriptionPlans>>>
export type ListSubscriptionPlansQueryError = ErrorType<unknown>


/**
 * @summary List available subscription plans
 */

export function useListSubscriptionPlans<TData = Awaited<ReturnType<typeof listSubscriptionPlans>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionPlans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSubscriptionPlansQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMySubscriptionUrl = () => {




  return `/api/subscription/me`
}

/**
 * @summary Get current user subscription status
 */
export const getMySubscription = async ( options?: RequestInit): Promise<UserSubscription> => {

  return customFetch<UserSubscription>(getGetMySubscriptionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMySubscriptionQueryKey = () => {
    return [
    `/api/subscription/me`
    ] as const;
    }


export const getGetMySubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getMySubscription>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMySubscription>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMySubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMySubscription>>> = ({ signal }) => getMySubscription({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMySubscription>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMySubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getMySubscription>>>
export type GetMySubscriptionQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get current user subscription status
 */

export function useGetMySubscription<TData = Awaited<ReturnType<typeof getMySubscription>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMySubscription>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMySubscriptionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubscribeUrl = () => {




  return `/api/subscription/subscribe`
}

/**
 * @summary Subscribe to a plan
 */
export const subscribe = async (subscribeInput: SubscribeInput, options?: RequestInit): Promise<UserSubscription> => {

  return customFetch<UserSubscription>(getSubscribeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(subscribeInput)
  }
);}





export const getSubscribeMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribe>>, TError,{data: BodyType<SubscribeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof subscribe>>, TError,{data: BodyType<SubscribeInput>}, TContext> => {

const mutationKey = ['subscribe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribe>>, {data: BodyType<SubscribeInput>}> = (props) => {
          const {data} = props ?? {};

          return  subscribe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof subscribe>>>
    export type SubscribeMutationBody = BodyType<SubscribeInput>
    export type SubscribeMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Subscribe to a plan
 */
export const useSubscribe = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribe>>, TError,{data: BodyType<SubscribeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof subscribe>>,
        TError,
        {data: BodyType<SubscribeInput>},
        TContext
      > => {
      return useMutation(getSubscribeMutationOptions(options));
    }

export const getCancelSubscriptionUrl = () => {




  return `/api/subscription/cancel`
}

/**
 * @summary Cancel current subscription
 */
export const cancelSubscription = async ( options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getCancelSubscriptionUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelSubscriptionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,void, TContext> => {

const mutationKey = ['cancelSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelSubscription>>, void> = () => {


          return  cancelSubscription(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSubscription>>>

    export type CancelSubscriptionMutationError = ErrorType<unknown>

    /**
 * @summary Cancel current subscription
 */
export const useCancelSubscription = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelSubscription>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCancelSubscriptionMutationOptions(options));
    }

export const getGetAnalysisTicketSummaryUrl = () => {




  return `/api/analysis-tickets`
}

/**
 * @summary Get the Apps in Toss analysis ticket balance and history
 */
export const getAnalysisTicketSummary = async ( options?: RequestInit): Promise<AnalysisTicketSummary> => {

  return customFetch<AnalysisTicketSummary>(getGetAnalysisTicketSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAnalysisTicketSummaryQueryKey = () => {
    return [
    `/api/analysis-tickets`
    ] as const;
    }


export const getGetAnalysisTicketSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisTicketSummary>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalysisTicketSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisTicketSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisTicketSummary>>> = ({ signal }) => getAnalysisTicketSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisTicketSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnalysisTicketSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisTicketSummary>>>
export type GetAnalysisTicketSummaryQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get the Apps in Toss analysis ticket balance and history
 */

export function useGetAnalysisTicketSummary<TData = Awaited<ReturnType<typeof getAnalysisTicketSummary>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalysisTicketSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAnalysisTicketSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAnalysisTicketHistoryUrl = (params?: GetAnalysisTicketHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/analysis-tickets/history?${stringifiedParams}` : `/api/analysis-tickets/history`
}

/**
 * @summary Get Apps in Toss analysis ticket history with cursor pagination
 */
export const getAnalysisTicketHistory = async (params?: GetAnalysisTicketHistoryParams, options?: RequestInit): Promise<AnalysisTicketHistoryPage> => {

  return customFetch<AnalysisTicketHistoryPage>(getGetAnalysisTicketHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAnalysisTicketHistoryQueryKey = (params?: GetAnalysisTicketHistoryParams,) => {
    return [
    `/api/analysis-tickets/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnalysisTicketHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisTicketHistory>>, TError = ErrorType<ErrorResponse>>(params?: GetAnalysisTicketHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalysisTicketHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisTicketHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisTicketHistory>>> = ({ signal }) => getAnalysisTicketHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisTicketHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnalysisTicketHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisTicketHistory>>>
export type GetAnalysisTicketHistoryQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get Apps in Toss analysis ticket history with cursor pagination
 */

export function useGetAnalysisTicketHistory<TData = Awaited<ReturnType<typeof getAnalysisTicketHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: GetAnalysisTicketHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalysisTicketHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAnalysisTicketHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGrantAnalysisTicketRewardUrl = () => {




  return `/api/analysis-tickets/rewards`
}

/**
 * @summary Grant one analysis ticket after a rewarded ad event
 */
export const grantAnalysisTicketReward = async (analysisTicketRewardInput: AnalysisTicketRewardInput, options?: RequestInit): Promise<AnalysisTicketRewardResult> => {

  return customFetch<AnalysisTicketRewardResult>(getGrantAnalysisTicketRewardUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(analysisTicketRewardInput)
  }
);}





export const getGrantAnalysisTicketRewardMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantAnalysisTicketReward>>, TError,{data: BodyType<AnalysisTicketRewardInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof grantAnalysisTicketReward>>, TError,{data: BodyType<AnalysisTicketRewardInput>}, TContext> => {

const mutationKey = ['grantAnalysisTicketReward'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantAnalysisTicketReward>>, {data: BodyType<AnalysisTicketRewardInput>}> = (props) => {
          const {data} = props ?? {};

          return  grantAnalysisTicketReward(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GrantAnalysisTicketRewardMutationResult = NonNullable<Awaited<ReturnType<typeof grantAnalysisTicketReward>>>
    export type GrantAnalysisTicketRewardMutationBody = BodyType<AnalysisTicketRewardInput>
    export type GrantAnalysisTicketRewardMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Grant one analysis ticket after a rewarded ad event
 */
export const useGrantAnalysisTicketReward = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantAnalysisTicketReward>>, TError,{data: BodyType<AnalysisTicketRewardInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof grantAnalysisTicketReward>>,
        TError,
        {data: BodyType<AnalysisTicketRewardInput>},
        TContext
      > => {
      return useMutation(getGrantAnalysisTicketRewardMutationOptions(options));
    }

export const getFetchPostingsUrl = () => {




  return `/api/companies/fetch-postings`
}

/**
 * @summary 필터 조건으로 실제 provider 채용공고 검색
 */
export const fetchPostings = async (fetchPostingsInput: FetchPostingsInput, options?: RequestInit): Promise<JobPosting[]> => {

  return customFetch<JobPosting[]>(getFetchPostingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fetchPostingsInput)
  }
);}





export const getFetchPostingsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fetchPostings>>, TError,{data: BodyType<FetchPostingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof fetchPostings>>, TError,{data: BodyType<FetchPostingsInput>}, TContext> => {

const mutationKey = ['fetchPostings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fetchPostings>>, {data: BodyType<FetchPostingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  fetchPostings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FetchPostingsMutationResult = NonNullable<Awaited<ReturnType<typeof fetchPostings>>>
    export type FetchPostingsMutationBody = BodyType<FetchPostingsInput>
    export type FetchPostingsMutationError = ErrorType<ErrorResponse>

    /**
 * @summary 필터 조건으로 실제 provider 채용공고 검색
 */
export const useFetchPostings = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fetchPostings>>, TError,{data: BodyType<FetchPostingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof fetchPostings>>,
        TError,
        {data: BodyType<FetchPostingsInput>},
        TContext
      > => {
      return useMutation(getFetchPostingsMutationOptions(options));
    }

export const getCreatePostingSearchConditionsUrl = () => {




  return `/api/companies/search-conditions`
}

/**
 * @summary Create a company posting search session
 */
export const createPostingSearchConditions = async (companyPostingSearchInput: CompanyPostingSearchInput, options?: RequestInit): Promise<CompanyPostingSearchResponse> => {

  return customFetch<CompanyPostingSearchResponse>(getCreatePostingSearchConditionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyPostingSearchInput)
  }
);}





export const getCreatePostingSearchConditionsMutationOptions = <TError = ErrorType<CompanySearchErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPostingSearchConditions>>, TError,{data: BodyType<CompanyPostingSearchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPostingSearchConditions>>, TError,{data: BodyType<CompanyPostingSearchInput>}, TContext> => {

const mutationKey = ['createPostingSearchConditions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPostingSearchConditions>>, {data: BodyType<CompanyPostingSearchInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPostingSearchConditions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePostingSearchConditionsMutationResult = NonNullable<Awaited<ReturnType<typeof createPostingSearchConditions>>>
    export type CreatePostingSearchConditionsMutationBody = BodyType<CompanyPostingSearchInput>
    export type CreatePostingSearchConditionsMutationError = ErrorType<CompanySearchErrorResponse | ErrorResponse>

    /**
 * @summary Create a company posting search session
 */
export const useCreatePostingSearchConditions = <TError = ErrorType<CompanySearchErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPostingSearchConditions>>, TError,{data: BodyType<CompanyPostingSearchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPostingSearchConditions>>,
        TError,
        {data: BodyType<CompanyPostingSearchInput>},
        TContext
      > => {
      return useMutation(getCreatePostingSearchConditionsMutationOptions(options));
    }

export const getFetchNextPostingSearchBatchUrl = (searchId: string,) => {




  return `/api/companies/posting-searches/${searchId}/next`
}

/**
 * @summary Fetch the next company posting batch
 */
export const fetchNextPostingSearchBatch = async (searchId: string,
    companyPostingNextInput: CompanyPostingNextInput, options?: RequestInit): Promise<CompanyPostingNextResponse> => {

  return customFetch<CompanyPostingNextResponse>(getFetchNextPostingSearchBatchUrl(searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyPostingNextInput)
  }
);}





export const getFetchNextPostingSearchBatchMutationOptions = <TError = ErrorType<CompanySearchErrorResponse | ErrorResponse | CompanyPostingNextResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fetchNextPostingSearchBatch>>, TError,{searchId: string;data: BodyType<CompanyPostingNextInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof fetchNextPostingSearchBatch>>, TError,{searchId: string;data: BodyType<CompanyPostingNextInput>}, TContext> => {

const mutationKey = ['fetchNextPostingSearchBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fetchNextPostingSearchBatch>>, {searchId: string;data: BodyType<CompanyPostingNextInput>}> = (props) => {
          const {searchId,data} = props ?? {};

          return  fetchNextPostingSearchBatch(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FetchNextPostingSearchBatchMutationResult = NonNullable<Awaited<ReturnType<typeof fetchNextPostingSearchBatch>>>
    export type FetchNextPostingSearchBatchMutationBody = BodyType<CompanyPostingNextInput>
    export type FetchNextPostingSearchBatchMutationError = ErrorType<CompanySearchErrorResponse | ErrorResponse | CompanyPostingNextResponse>

    /**
 * @summary Fetch the next company posting batch
 */
export const useFetchNextPostingSearchBatch = <TError = ErrorType<CompanySearchErrorResponse | ErrorResponse | CompanyPostingNextResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fetchNextPostingSearchBatch>>, TError,{searchId: string;data: BodyType<CompanyPostingNextInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof fetchNextPostingSearchBatch>>,
        TError,
        {searchId: string;data: BodyType<CompanyPostingNextInput>},
        TContext
      > => {
      return useMutation(getFetchNextPostingSearchBatchMutationOptions(options));
    }

export const getSavePostingSearchCandidatesUrl = (searchId: string,) => {




  return `/api/companies/posting-searches/${searchId}/save`
}

/**
 * @summary Save delivered company posting candidates
 */
export const savePostingSearchCandidates = async (searchId: string,
    companyPostingSaveInput: CompanyPostingSaveInput, options?: RequestInit): Promise<CompanyPostingSaveResponse> => {

  return customFetch<CompanyPostingSaveResponse>(getSavePostingSearchCandidatesUrl(searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyPostingSaveInput)
  }
);}





export const getSavePostingSearchCandidatesMutationOptions = <TError = ErrorType<CompanySearchErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePostingSearchCandidates>>, TError,{searchId: string;data: BodyType<CompanyPostingSaveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof savePostingSearchCandidates>>, TError,{searchId: string;data: BodyType<CompanyPostingSaveInput>}, TContext> => {

const mutationKey = ['savePostingSearchCandidates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof savePostingSearchCandidates>>, {searchId: string;data: BodyType<CompanyPostingSaveInput>}> = (props) => {
          const {searchId,data} = props ?? {};

          return  savePostingSearchCandidates(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SavePostingSearchCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof savePostingSearchCandidates>>>
    export type SavePostingSearchCandidatesMutationBody = BodyType<CompanyPostingSaveInput>
    export type SavePostingSearchCandidatesMutationError = ErrorType<CompanySearchErrorResponse | ErrorResponse>

    /**
 * @summary Save delivered company posting candidates
 */
export const useSavePostingSearchCandidates = <TError = ErrorType<CompanySearchErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePostingSearchCandidates>>, TError,{searchId: string;data: BodyType<CompanyPostingSaveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof savePostingSearchCandidates>>,
        TError,
        {searchId: string;data: BodyType<CompanyPostingSaveInput>},
        TContext
      > => {
      return useMutation(getSavePostingSearchCandidatesMutationOptions(options));
    }

export const getFetchPostingSearchDetailUrl = (searchId: string,) => {




  return `/api/companies/posting-searches/${searchId}/detail`
}

/**
 * @summary Fetch detail for a delivered company posting candidate
 */
export const fetchPostingSearchDetail = async (searchId: string,
    companyPostingDetailInput: CompanyPostingDetailInput, options?: RequestInit): Promise<CompanyPostingDetailResponse> => {

  return customFetch<CompanyPostingDetailResponse>(getFetchPostingSearchDetailUrl(searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyPostingDetailInput)
  }
);}





export const getFetchPostingSearchDetailMutationOptions = <TError = ErrorType<CompanySearchErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fetchPostingSearchDetail>>, TError,{searchId: string;data: BodyType<CompanyPostingDetailInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof fetchPostingSearchDetail>>, TError,{searchId: string;data: BodyType<CompanyPostingDetailInput>}, TContext> => {

const mutationKey = ['fetchPostingSearchDetail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fetchPostingSearchDetail>>, {searchId: string;data: BodyType<CompanyPostingDetailInput>}> = (props) => {
          const {searchId,data} = props ?? {};

          return  fetchPostingSearchDetail(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FetchPostingSearchDetailMutationResult = NonNullable<Awaited<ReturnType<typeof fetchPostingSearchDetail>>>
    export type FetchPostingSearchDetailMutationBody = BodyType<CompanyPostingDetailInput>
    export type FetchPostingSearchDetailMutationError = ErrorType<CompanySearchErrorResponse | ErrorResponse>

    /**
 * @summary Fetch detail for a delivered company posting candidate
 */
export const useFetchPostingSearchDetail = <TError = ErrorType<CompanySearchErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fetchPostingSearchDetail>>, TError,{searchId: string;data: BodyType<CompanyPostingDetailInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof fetchPostingSearchDetail>>,
        TError,
        {searchId: string;data: BodyType<CompanyPostingDetailInput>},
        TContext
      > => {
      return useMutation(getFetchPostingSearchDetailMutationOptions(options));
    }

export const getRecommendCompaniesUrl = () => {




  return `/api/companies/recommend`
}

/**
 * @summary 이력서 기반으로 회사 추천 (isRecommended 갱신)
 */
export const recommendCompanies = async (recommendInput: RecommendInput, options?: RequestInit): Promise<Company[]> => {

  return customFetch<Company[]>(getRecommendCompaniesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recommendInput)
  }
);}





export const getRecommendCompaniesMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recommendCompanies>>, TError,{data: BodyType<RecommendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recommendCompanies>>, TError,{data: BodyType<RecommendInput>}, TContext> => {

const mutationKey = ['recommendCompanies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recommendCompanies>>, {data: BodyType<RecommendInput>}> = (props) => {
          const {data} = props ?? {};

          return  recommendCompanies(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecommendCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof recommendCompanies>>>
    export type RecommendCompaniesMutationBody = BodyType<RecommendInput>
    export type RecommendCompaniesMutationError = ErrorType<ErrorResponse>

    /**
 * @summary 이력서 기반으로 회사 추천 (isRecommended 갱신)
 */
export const useRecommendCompanies = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recommendCompanies>>, TError,{data: BodyType<RecommendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recommendCompanies>>,
        TError,
        {data: BodyType<RecommendInput>},
        TContext
      > => {
      return useMutation(getRecommendCompaniesMutationOptions(options));
    }

export const getCreateCompanyRecommendationTaskUrl = () => {




  return `/api/companies/recommend/tasks`
}

/**
 * @summary Queue company recommendations for a pinned resume revision and company snapshot
 */
export const createCompanyRecommendationTask = async (companyRecommendationTaskInput: CompanyRecommendationTaskInput, options?: RequestInit): Promise<AiTaskAccepted> => {

  return customFetch<AiTaskAccepted>(getCreateCompanyRecommendationTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyRecommendationTaskInput)
  }
);}





export const getCreateCompanyRecommendationTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyRecommendationTask>>, TError,{data: BodyType<CompanyRecommendationTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyRecommendationTask>>, TError,{data: BodyType<CompanyRecommendationTaskInput>}, TContext> => {

const mutationKey = ['createCompanyRecommendationTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyRecommendationTask>>, {data: BodyType<CompanyRecommendationTaskInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCompanyRecommendationTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyRecommendationTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyRecommendationTask>>>
    export type CreateCompanyRecommendationTaskMutationBody = BodyType<CompanyRecommendationTaskInput>
    export type CreateCompanyRecommendationTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Queue company recommendations for a pinned resume revision and company snapshot
 */
export const useCreateCompanyRecommendationTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyRecommendationTask>>, TError,{data: BodyType<CompanyRecommendationTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCompanyRecommendationTask>>,
        TError,
        {data: BodyType<CompanyRecommendationTaskInput>},
        TContext
      > => {
      return useMutation(getCreateCompanyRecommendationTaskMutationOptions(options));
    }

export const getCreateJobPostingSearchTaskUrl = () => {




  return `/api/companies/fetch-postings/tasks`
}

/**
 * @summary Queue a durable company posting search
 */
export const createJobPostingSearchTask = async (jobPostingSearchTaskInput: JobPostingSearchTaskInput, options?: RequestInit): Promise<AiTaskAccepted> => {

  return customFetch<AiTaskAccepted>(getCreateJobPostingSearchTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobPostingSearchTaskInput)
  }
);}





export const getCreateJobPostingSearchTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobPostingSearchTask>>, TError,{data: BodyType<JobPostingSearchTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createJobPostingSearchTask>>, TError,{data: BodyType<JobPostingSearchTaskInput>}, TContext> => {

const mutationKey = ['createJobPostingSearchTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJobPostingSearchTask>>, {data: BodyType<JobPostingSearchTaskInput>}> = (props) => {
          const {data} = props ?? {};

          return  createJobPostingSearchTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateJobPostingSearchTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createJobPostingSearchTask>>>
    export type CreateJobPostingSearchTaskMutationBody = BodyType<JobPostingSearchTaskInput>
    export type CreateJobPostingSearchTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Queue a durable company posting search
 */
export const useCreateJobPostingSearchTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobPostingSearchTask>>, TError,{data: BodyType<JobPostingSearchTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createJobPostingSearchTask>>,
        TError,
        {data: BodyType<JobPostingSearchTaskInput>},
        TContext
      > => {
      return useMutation(getCreateJobPostingSearchTaskMutationOptions(options));
    }

export const getCreateJobPostingImportTaskUrl = () => {




  return `/api/companies/fetch-posting/tasks`
}

/**
 * @summary Queue SSRF-safe posting HTML/detail/OCR import
 */
export const createJobPostingImportTask = async (jobPostingImportTaskInput: JobPostingImportTaskInput, options?: RequestInit): Promise<AiTaskAccepted> => {

  return customFetch<AiTaskAccepted>(getCreateJobPostingImportTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobPostingImportTaskInput)
  }
);}





export const getCreateJobPostingImportTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobPostingImportTask>>, TError,{data: BodyType<JobPostingImportTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createJobPostingImportTask>>, TError,{data: BodyType<JobPostingImportTaskInput>}, TContext> => {

const mutationKey = ['createJobPostingImportTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJobPostingImportTask>>, {data: BodyType<JobPostingImportTaskInput>}> = (props) => {
          const {data} = props ?? {};

          return  createJobPostingImportTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateJobPostingImportTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createJobPostingImportTask>>>
    export type CreateJobPostingImportTaskMutationBody = BodyType<JobPostingImportTaskInput>
    export type CreateJobPostingImportTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Queue SSRF-safe posting HTML/detail/OCR import
 */
export const useCreateJobPostingImportTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobPostingImportTask>>, TError,{data: BodyType<JobPostingImportTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createJobPostingImportTask>>,
        TError,
        {data: BodyType<JobPostingImportTaskInput>},
        TContext
      > => {
      return useMutation(getCreateJobPostingImportTaskMutationOptions(options));
    }

export const getListCompaniesUrl = () => {




  return `/api/companies`
}

/**
 * @summary List all companies the user has added
 */
export const listCompanies = async ( options?: RequestInit): Promise<Company[]> => {

  return customFetch<Company[]>(getListCompaniesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCompaniesQueryKey = () => {
    return [
    `/api/companies`
    ] as const;
    }


export const getListCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listCompanies>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompanies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCompaniesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanies>>> = ({ signal }) => listCompanies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanies>>>
export type ListCompaniesQueryError = ErrorType<unknown>


/**
 * @summary List all companies the user has added
 */

export function useListCompanies<TData = Awaited<ReturnType<typeof listCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompanies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCompaniesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCompanyUrl = () => {




  return `/api/companies`
}

/**
 * @summary Add a company profile
 */
export const createCompany = async (companyInput: CompanyInput, options?: RequestInit): Promise<Company> => {

  return customFetch<Company>(getCreateCompanyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyInput)
  }
);}





export const getCreateCompanyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CompanyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CompanyInput>}, TContext> => {

const mutationKey = ['createCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompany>>, {data: BodyType<CompanyInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCompany(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof createCompany>>>
    export type CreateCompanyMutationBody = BodyType<CompanyInput>
    export type CreateCompanyMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Add a company profile
 */
export const useCreateCompany = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CompanyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCompany>>,
        TError,
        {data: BodyType<CompanyInput>},
        TContext
      > => {
      return useMutation(getCreateCompanyMutationOptions(options));
    }

export const getGetCompanyUrl = (id: number,) => {




  return `/api/companies/${id}`
}

/**
 * @summary Get a company profile
 */
export const getCompany = async (id: number, options?: RequestInit): Promise<Company> => {

  return customFetch<Company>(getGetCompanyUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyQueryKey = (id: number,) => {
    return [
    `/api/companies/${id}`
    ] as const;
    }


export const getGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanyQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a company profile
 */

export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCompanyQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCompanyUrl = (id: number,) => {




  return `/api/companies/${id}`
}

/**
 * @summary Update a company profile
 */
export const updateCompany = async (id: number,
    companyUpdate: CompanyUpdate, options?: RequestInit): Promise<Company> => {

  return customFetch<Company>(getUpdateCompanyUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyUpdate)
  }
);}





export const getUpdateCompanyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{id: number;data: BodyType<CompanyUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{id: number;data: BodyType<CompanyUpdate>}, TContext> => {

const mutationKey = ['updateCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompany>>, {id: number;data: BodyType<CompanyUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCompany(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompany>>>
    export type UpdateCompanyMutationBody = BodyType<CompanyUpdate>
    export type UpdateCompanyMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a company profile
 */
export const useUpdateCompany = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{id: number;data: BodyType<CompanyUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCompany>>,
        TError,
        {id: number;data: BodyType<CompanyUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCompanyMutationOptions(options));
    }

export const getDeleteCompanyUrl = (id: number,) => {




  return `/api/companies/${id}`
}

/**
 * @summary Delete a company profile
 */
export const deleteCompany = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCompanyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCompanyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompany>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompany(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompany>>>

    export type DeleteCompanyMutationError = ErrorType<unknown>

    /**
 * @summary Delete a company profile
 */
export const useDeleteCompany = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompany>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCompanyMutationOptions(options));
    }

export const getListResumesUrl = () => {




  return `/api/resumes`
}

/**
 * @summary List all resumes of the user
 */
export const listResumes = async ( options?: RequestInit): Promise<Resume[]> => {

  return customFetch<Resume[]>(getListResumesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListResumesQueryKey = () => {
    return [
    `/api/resumes`
    ] as const;
    }


export const getListResumesQueryOptions = <TData = Awaited<ReturnType<typeof listResumes>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listResumes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListResumesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listResumes>>> = ({ signal }) => listResumes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listResumes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListResumesQueryResult = NonNullable<Awaited<ReturnType<typeof listResumes>>>
export type ListResumesQueryError = ErrorType<unknown>


/**
 * @summary List all resumes of the user
 */

export function useListResumes<TData = Awaited<ReturnType<typeof listResumes>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listResumes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListResumesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateResumeUrl = () => {




  return `/api/resumes`
}

/**
 * @summary Create a resume with JSON body
 */
export const createResume = async (resumeInput: ResumeInput, options?: RequestInit): Promise<Resume> => {

  return customFetch<Resume>(getCreateResumeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resumeInput)
  }
);}





export const getCreateResumeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResume>>, TError,{data: BodyType<ResumeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createResume>>, TError,{data: BodyType<ResumeInput>}, TContext> => {

const mutationKey = ['createResume'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResume>>, {data: BodyType<ResumeInput>}> = (props) => {
          const {data} = props ?? {};

          return  createResume(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResumeMutationResult = NonNullable<Awaited<ReturnType<typeof createResume>>>
    export type CreateResumeMutationBody = BodyType<ResumeInput>
    export type CreateResumeMutationError = ErrorType<unknown>

    /**
 * @summary Create a resume with JSON body
 */
export const useCreateResume = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResume>>, TError,{data: BodyType<ResumeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createResume>>,
        TError,
        {data: BodyType<ResumeInput>},
        TContext
      > => {
      return useMutation(getCreateResumeMutationOptions(options));
    }

export const getSpellcheckResumeUrl = (id: number,) => {




  return `/api/resumes/${id}/spellcheck`
}

/**
 * @summary AI 오탈자·맞춤법 검사
 */
export const spellcheckResume = async (id: number,
    spellcheckInput: SpellcheckInput, options?: RequestInit): Promise<SpellcheckResult> => {

  return customFetch<SpellcheckResult>(getSpellcheckResumeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(spellcheckInput)
  }
);}





export const getSpellcheckResumeMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof spellcheckResume>>, TError,{id: number;data: BodyType<SpellcheckInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof spellcheckResume>>, TError,{id: number;data: BodyType<SpellcheckInput>}, TContext> => {

const mutationKey = ['spellcheckResume'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof spellcheckResume>>, {id: number;data: BodyType<SpellcheckInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  spellcheckResume(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SpellcheckResumeMutationResult = NonNullable<Awaited<ReturnType<typeof spellcheckResume>>>
    export type SpellcheckResumeMutationBody = BodyType<SpellcheckInput>
    export type SpellcheckResumeMutationError = ErrorType<ErrorResponse>

    /**
 * @summary AI 오탈자·맞춤법 검사
 */
export const useSpellcheckResume = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof spellcheckResume>>, TError,{id: number;data: BodyType<SpellcheckInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof spellcheckResume>>,
        TError,
        {id: number;data: BodyType<SpellcheckInput>},
        TContext
      > => {
      return useMutation(getSpellcheckResumeMutationOptions(options));
    }

export const getCreateResumeSpellcheckTaskUrl = (id: number,) => {




  return `/api/resumes/${id}/spellcheck/tasks`
}

/**
 * @summary Queue a spellcheck for the persisted resume revision
 */
export const createResumeSpellcheckTask = async (id: number, options?: RequestInit): Promise<AiTaskAccepted> => {

  return customFetch<AiTaskAccepted>(getCreateResumeSpellcheckTaskUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateResumeSpellcheckTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResumeSpellcheckTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createResumeSpellcheckTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['createResumeSpellcheckTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResumeSpellcheckTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  createResumeSpellcheckTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResumeSpellcheckTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createResumeSpellcheckTask>>>

    export type CreateResumeSpellcheckTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Queue a spellcheck for the persisted resume revision
 */
export const useCreateResumeSpellcheckTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResumeSpellcheckTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createResumeSpellcheckTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCreateResumeSpellcheckTaskMutationOptions(options));
    }

export const getCreateCareerAnalysisTaskUrl = (id: number,) => {




  return `/api/resumes/${id}/career-analysis/tasks`
}

/**
 * @summary Queue career analysis for the latest resume revision
 */
export const createCareerAnalysisTask = async (id: number, options?: RequestInit): Promise<AiTaskAccepted> => {

  return customFetch<AiTaskAccepted>(getCreateCareerAnalysisTaskUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateCareerAnalysisTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCareerAnalysisTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCareerAnalysisTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['createCareerAnalysisTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCareerAnalysisTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  createCareerAnalysisTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCareerAnalysisTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createCareerAnalysisTask>>>

    export type CreateCareerAnalysisTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Queue career analysis for the latest resume revision
 */
export const useCreateCareerAnalysisTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCareerAnalysisTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCareerAnalysisTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCreateCareerAnalysisTaskMutationOptions(options));
    }

export const getCreateResumeUploadTaskUrl = () => {




  return `/api/resumes/upload/tasks`
}

/**
 * @summary Persist a resume upload and queue extraction
 */
export const createResumeUploadTask = async (resumeUploadTaskInput: ResumeUploadTaskInput, options?: RequestInit): Promise<AiTaskAccepted> => {
    const formData = new FormData();
formData.append(`file`, resumeUploadTaskInput.file);
if(resumeUploadTaskInput.title !== undefined) {
 formData.append(`title`, resumeUploadTaskInput.title);
 }

  return customFetch<AiTaskAccepted>(getCreateResumeUploadTaskUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getCreateResumeUploadTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResumeUploadTask>>, TError,{data: BodyType<ResumeUploadTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createResumeUploadTask>>, TError,{data: BodyType<ResumeUploadTaskInput>}, TContext> => {

const mutationKey = ['createResumeUploadTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResumeUploadTask>>, {data: BodyType<ResumeUploadTaskInput>}> = (props) => {
          const {data} = props ?? {};

          return  createResumeUploadTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResumeUploadTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createResumeUploadTask>>>
    export type CreateResumeUploadTaskMutationBody = BodyType<ResumeUploadTaskInput>
    export type CreateResumeUploadTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Persist a resume upload and queue extraction
 */
export const useCreateResumeUploadTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResumeUploadTask>>, TError,{data: BodyType<ResumeUploadTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createResumeUploadTask>>,
        TError,
        {data: BodyType<ResumeUploadTaskInput>},
        TContext
      > => {
      return useMutation(getCreateResumeUploadTaskMutationOptions(options));
    }

export const getGetResumeUrl = (id: number,) => {




  return `/api/resumes/${id}`
}

/**
 * @summary Get a resume
 */
export const getResume = async (id: number, options?: RequestInit): Promise<Resume> => {

  return customFetch<Resume>(getGetResumeUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResumeQueryKey = (id: number,) => {
    return [
    `/api/resumes/${id}`
    ] as const;
    }


export const getGetResumeQueryOptions = <TData = Awaited<ReturnType<typeof getResume>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResume>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResumeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResume>>> = ({ signal }) => getResume(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResume>>, TError, TData> & { queryKey: QueryKey }
}

export type GetResumeQueryResult = NonNullable<Awaited<ReturnType<typeof getResume>>>
export type GetResumeQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a resume
 */

export function useGetResume<TData = Awaited<ReturnType<typeof getResume>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResume>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetResumeQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateResumeUrl = (id: number,) => {




  return `/api/resumes/${id}`
}

/**
 * @summary Update a resume
 */
export const updateResume = async (id: number,
    resumeUpdate: ResumeUpdate, options?: RequestInit): Promise<Resume> => {

  return customFetch<Resume>(getUpdateResumeUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resumeUpdate)
  }
);}





export const getUpdateResumeMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResume>>, TError,{id: number;data: BodyType<ResumeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateResume>>, TError,{id: number;data: BodyType<ResumeUpdate>}, TContext> => {

const mutationKey = ['updateResume'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateResume>>, {id: number;data: BodyType<ResumeUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateResume(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateResumeMutationResult = NonNullable<Awaited<ReturnType<typeof updateResume>>>
    export type UpdateResumeMutationBody = BodyType<ResumeUpdate>
    export type UpdateResumeMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a resume
 */
export const useUpdateResume = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResume>>, TError,{id: number;data: BodyType<ResumeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateResume>>,
        TError,
        {id: number;data: BodyType<ResumeUpdate>},
        TContext
      > => {
      return useMutation(getUpdateResumeMutationOptions(options));
    }

export const getDeleteResumeUrl = (id: number,) => {




  return `/api/resumes/${id}`
}

/**
 * @summary Delete a resume
 */
export const deleteResume = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteResumeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteResumeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResume>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteResume>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteResume'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteResume>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteResume(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteResumeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteResume>>>

    export type DeleteResumeMutationError = ErrorType<unknown>

    /**
 * @summary Delete a resume
 */
export const useDeleteResume = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResume>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteResume>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteResumeMutationOptions(options));
    }

export const getGenerateCoverLetterUrl = () => {




  return `/api/cover-letter/generate`
}

/**
 * @summary Generate a cover letter from an audio recording
 */
export const generateCoverLetter = async (coverLetterAudioInput: CoverLetterAudioInput, options?: RequestInit): Promise<CoverLetterGenerationResult> => {
    const formData = new FormData();
formData.append(`audio`, coverLetterAudioInput.audio);

  return customFetch<CoverLetterGenerationResult>(getGenerateCoverLetterUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getGenerateCoverLetterMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCoverLetter>>, TError,{data: BodyType<CoverLetterAudioInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateCoverLetter>>, TError,{data: BodyType<CoverLetterAudioInput>}, TContext> => {

const mutationKey = ['generateCoverLetter'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCoverLetter>>, {data: BodyType<CoverLetterAudioInput>}> = (props) => {
          const {data} = props ?? {};

          return  generateCoverLetter(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateCoverLetterMutationResult = NonNullable<Awaited<ReturnType<typeof generateCoverLetter>>>
    export type GenerateCoverLetterMutationBody = BodyType<CoverLetterAudioInput>
    export type GenerateCoverLetterMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Generate a cover letter from an audio recording
 */
export const useGenerateCoverLetter = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCoverLetter>>, TError,{data: BodyType<CoverLetterAudioInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateCoverLetter>>,
        TError,
        {data: BodyType<CoverLetterAudioInput>},
        TContext
      > => {
      return useMutation(getGenerateCoverLetterMutationOptions(options));
    }

export const getGenerateGuidedPromptsUrl = () => {




  return `/api/cover-letter/guided-prompts`
}

/**
 * @summary Generate guided recording prompts from a resume
 */
export const generateGuidedPrompts = async (guidedPromptsInput: GuidedPromptsInput, options?: RequestInit): Promise<GuidedPromptsResult> => {

  return customFetch<GuidedPromptsResult>(getGenerateGuidedPromptsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(guidedPromptsInput)
  }
);}





export const getGenerateGuidedPromptsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateGuidedPrompts>>, TError,{data: BodyType<GuidedPromptsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateGuidedPrompts>>, TError,{data: BodyType<GuidedPromptsInput>}, TContext> => {

const mutationKey = ['generateGuidedPrompts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateGuidedPrompts>>, {data: BodyType<GuidedPromptsInput>}> = (props) => {
          const {data} = props ?? {};

          return  generateGuidedPrompts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateGuidedPromptsMutationResult = NonNullable<Awaited<ReturnType<typeof generateGuidedPrompts>>>
    export type GenerateGuidedPromptsMutationBody = BodyType<GuidedPromptsInput>
    export type GenerateGuidedPromptsMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Generate guided recording prompts from a resume
 */
export const useGenerateGuidedPrompts = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateGuidedPrompts>>, TError,{data: BodyType<GuidedPromptsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateGuidedPrompts>>,
        TError,
        {data: BodyType<GuidedPromptsInput>},
        TContext
      > => {
      return useMutation(getGenerateGuidedPromptsMutationOptions(options));
    }

export const getCreateGuidedPromptsTaskUrl = () => {




  return `/api/cover-letter/guided-prompts/tasks`
}

/**
 * @summary Queue guided recording prompt generation
 */
export const createGuidedPromptsTask = async (guidedPromptsInput: GuidedPromptsInput, options?: RequestInit): Promise<AiTaskAccepted> => {

  return customFetch<AiTaskAccepted>(getCreateGuidedPromptsTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(guidedPromptsInput)
  }
);}





export const getCreateGuidedPromptsTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuidedPromptsTask>>, TError,{data: BodyType<GuidedPromptsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createGuidedPromptsTask>>, TError,{data: BodyType<GuidedPromptsInput>}, TContext> => {

const mutationKey = ['createGuidedPromptsTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGuidedPromptsTask>>, {data: BodyType<GuidedPromptsInput>}> = (props) => {
          const {data} = props ?? {};

          return  createGuidedPromptsTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGuidedPromptsTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createGuidedPromptsTask>>>
    export type CreateGuidedPromptsTaskMutationBody = BodyType<GuidedPromptsInput>
    export type CreateGuidedPromptsTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Queue guided recording prompt generation
 */
export const useCreateGuidedPromptsTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuidedPromptsTask>>, TError,{data: BodyType<GuidedPromptsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createGuidedPromptsTask>>,
        TError,
        {data: BodyType<GuidedPromptsInput>},
        TContext
      > => {
      return useMutation(getCreateGuidedPromptsTaskMutationOptions(options));
    }

export const getCreateCoverLetterAudioTaskUrl = () => {




  return `/api/cover-letter/audio/tasks`
}

/**
 * @summary Persist audio and queue cover letter generation
 */
export const createCoverLetterAudioTask = async (coverLetterAudioInput: CoverLetterAudioInput, options?: RequestInit): Promise<AiTaskAccepted> => {
    const formData = new FormData();
formData.append(`audio`, coverLetterAudioInput.audio);

  return customFetch<AiTaskAccepted>(getCreateCoverLetterAudioTaskUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getCreateCoverLetterAudioTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCoverLetterAudioTask>>, TError,{data: BodyType<CoverLetterAudioInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCoverLetterAudioTask>>, TError,{data: BodyType<CoverLetterAudioInput>}, TContext> => {

const mutationKey = ['createCoverLetterAudioTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCoverLetterAudioTask>>, {data: BodyType<CoverLetterAudioInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCoverLetterAudioTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCoverLetterAudioTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createCoverLetterAudioTask>>>
    export type CreateCoverLetterAudioTaskMutationBody = BodyType<CoverLetterAudioInput>
    export type CreateCoverLetterAudioTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Persist audio and queue cover letter generation
 */
export const useCreateCoverLetterAudioTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCoverLetterAudioTask>>, TError,{data: BodyType<CoverLetterAudioInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCoverLetterAudioTask>>,
        TError,
        {data: BodyType<CoverLetterAudioInput>},
        TContext
      > => {
      return useMutation(getCreateCoverLetterAudioTaskMutationOptions(options));
    }

export const getListAnalysesUrl = () => {




  return `/api/analyses`
}

/**
 * @summary List all analyses for the user
 */
export const listAnalyses = async ( options?: RequestInit): Promise<Analysis[]> => {

  return customFetch<Analysis[]>(getListAnalysesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAnalysesQueryKey = () => {
    return [
    `/api/analyses`
    ] as const;
    }


export const getListAnalysesQueryOptions = <TData = Awaited<ReturnType<typeof listAnalyses>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAnalyses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnalysesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnalyses>>> = ({ signal }) => listAnalyses({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAnalyses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAnalysesQueryResult = NonNullable<Awaited<ReturnType<typeof listAnalyses>>>
export type ListAnalysesQueryError = ErrorType<unknown>


/**
 * @summary List all analyses for the user
 */

export function useListAnalyses<TData = Awaited<ReturnType<typeof listAnalyses>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAnalyses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAnalysesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAnalysisUrl = () => {




  return `/api/analyses`
}

/**
 * @summary Start an AI analysis for a resume + company
 */
export const createAnalysis = async (analysisInput: AnalysisInput, options?: RequestInit): Promise<Analysis> => {

  return customFetch<Analysis>(getCreateAnalysisUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(analysisInput)
  }
);}





export const getCreateAnalysisMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysis>>, TError,{data: BodyType<AnalysisInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnalysis>>, TError,{data: BodyType<AnalysisInput>}, TContext> => {

const mutationKey = ['createAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalysis>>, {data: BodyType<AnalysisInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAnalysis(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalysis>>>
    export type CreateAnalysisMutationBody = BodyType<AnalysisInput>
    export type CreateAnalysisMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Start an AI analysis for a resume + company
 */
export const useCreateAnalysis = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysis>>, TError,{data: BodyType<AnalysisInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAnalysis>>,
        TError,
        {data: BodyType<AnalysisInput>},
        TContext
      > => {
      return useMutation(getCreateAnalysisMutationOptions(options));
    }

export const getGetAnalysisUrl = (id: number,) => {




  return `/api/analyses/${id}`
}

/**
 * @summary Get an analysis result
 */
export const getAnalysis = async (id: number, options?: RequestInit): Promise<Analysis> => {

  return customFetch<Analysis>(getGetAnalysisUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAnalysisQueryKey = (id: number,) => {
    return [
    `/api/analyses/${id}`
    ] as const;
    }


export const getGetAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysis>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysis>>> = ({ signal }) => getAnalysis(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysis>>>
export type GetAnalysisQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get an analysis result
 */

export function useGetAnalysis<TData = Awaited<ReturnType<typeof getAnalysis>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAnalysisQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAnalysisTaskUrl = () => {




  return `/api/analyses/tasks`
}

/**
 * @summary Atomically consume access and queue an AI analysis
 */
export const createAnalysisTask = async (analysisInput: AnalysisInput, options?: RequestInit): Promise<AiTaskAccepted> => {

  return customFetch<AiTaskAccepted>(getCreateAnalysisTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(analysisInput)
  }
);}





export const getCreateAnalysisTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysisTask>>, TError,{data: BodyType<AnalysisInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnalysisTask>>, TError,{data: BodyType<AnalysisInput>}, TContext> => {

const mutationKey = ['createAnalysisTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalysisTask>>, {data: BodyType<AnalysisInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAnalysisTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalysisTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalysisTask>>>
    export type CreateAnalysisTaskMutationBody = BodyType<AnalysisInput>
    export type CreateAnalysisTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Atomically consume access and queue an AI analysis
 */
export const useCreateAnalysisTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysisTask>>, TError,{data: BodyType<AnalysisInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAnalysisTask>>,
        TError,
        {data: BodyType<AnalysisInput>},
        TContext
      > => {
      return useMutation(getCreateAnalysisTaskMutationOptions(options));
    }

export const getRetryAnalysisTaskUrl = (id: number,) => {




  return `/api/analyses/${id}/retry/tasks`
}

/**
 * @summary Queue a single uncharged retry for a failed analysis
 */
export const retryAnalysisTask = async (id: number, options?: RequestInit): Promise<AiTaskAccepted> => {

  return customFetch<AiTaskAccepted>(getRetryAnalysisTaskUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryAnalysisTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAnalysisTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryAnalysisTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['retryAnalysisTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryAnalysisTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  retryAnalysisTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryAnalysisTaskMutationResult = NonNullable<Awaited<ReturnType<typeof retryAnalysisTask>>>

    export type RetryAnalysisTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Queue a single uncharged retry for a failed analysis
 */
export const useRetryAnalysisTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAnalysisTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryAnalysisTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRetryAnalysisTaskMutationOptions(options));
    }

export const getRetryAnalysisUrl = (id: number,) => {




  return `/api/analyses/${id}/retry`
}

/**
 * @summary Retry a failed analysis with the same resume and company
 */
export const retryAnalysis = async (id: number, options?: RequestInit): Promise<Analysis> => {

  return customFetch<Analysis>(getRetryAnalysisUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryAnalysisMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAnalysis>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryAnalysis>>, TError,{id: number}, TContext> => {

const mutationKey = ['retryAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryAnalysis>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  retryAnalysis(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof retryAnalysis>>>

    export type RetryAnalysisMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Retry a failed analysis with the same resume and company
 */
export const useRetryAnalysis = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAnalysis>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryAnalysis>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRetryAnalysisMutationOptions(options));
    }

export const getListInterviewsUrl = () => {




  return `/api/interviews`
}

/**
 * @summary List all interview sessions for the user
 */
export const listInterviews = async ( options?: RequestInit): Promise<InterviewSession[]> => {

  return customFetch<InterviewSession[]>(getListInterviewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInterviewsQueryKey = () => {
    return [
    `/api/interviews`
    ] as const;
    }


export const getListInterviewsQueryOptions = <TData = Awaited<ReturnType<typeof listInterviews>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInterviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInterviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInterviews>>> = ({ signal }) => listInterviews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInterviews>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInterviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listInterviews>>>
export type ListInterviewsQueryError = ErrorType<unknown>


/**
 * @summary List all interview sessions for the user
 */

export function useListInterviews<TData = Awaited<ReturnType<typeof listInterviews>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInterviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInterviewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateInterviewUrl = () => {




  return `/api/interviews`
}

/**
 * @summary Generate interview questions for a resume + company
 */
export const createInterview = async (interviewInput: InterviewInput, options?: RequestInit): Promise<InterviewSession> => {

  return customFetch<InterviewSession>(getCreateInterviewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(interviewInput)
  }
);}





export const getCreateInterviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterview>>, TError,{data: BodyType<InterviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInterview>>, TError,{data: BodyType<InterviewInput>}, TContext> => {

const mutationKey = ['createInterview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInterview>>, {data: BodyType<InterviewInput>}> = (props) => {
          const {data} = props ?? {};

          return  createInterview(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInterviewMutationResult = NonNullable<Awaited<ReturnType<typeof createInterview>>>
    export type CreateInterviewMutationBody = BodyType<InterviewInput>
    export type CreateInterviewMutationError = ErrorType<unknown>

    /**
 * @summary Generate interview questions for a resume + company
 */
export const useCreateInterview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterview>>, TError,{data: BodyType<InterviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInterview>>,
        TError,
        {data: BodyType<InterviewInput>},
        TContext
      > => {
      return useMutation(getCreateInterviewMutationOptions(options));
    }

export const getCreateInterviewTaskUrl = () => {




  return `/api/interviews/tasks`
}

/**
 * @summary Atomically create an interview session and queue questions
 */
export const createInterviewTask = async (interviewInput: InterviewInput, options?: RequestInit): Promise<AiTaskAccepted> => {

  return customFetch<AiTaskAccepted>(getCreateInterviewTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(interviewInput)
  }
);}





export const getCreateInterviewTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterviewTask>>, TError,{data: BodyType<InterviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInterviewTask>>, TError,{data: BodyType<InterviewInput>}, TContext> => {

const mutationKey = ['createInterviewTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInterviewTask>>, {data: BodyType<InterviewInput>}> = (props) => {
          const {data} = props ?? {};

          return  createInterviewTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInterviewTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createInterviewTask>>>
    export type CreateInterviewTaskMutationBody = BodyType<InterviewInput>
    export type CreateInterviewTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Atomically create an interview session and queue questions
 */
export const useCreateInterviewTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterviewTask>>, TError,{data: BodyType<InterviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInterviewTask>>,
        TError,
        {data: BodyType<InterviewInput>},
        TContext
      > => {
      return useMutation(getCreateInterviewTaskMutationOptions(options));
    }

export const getGetInterviewUrl = (id: number,) => {




  return `/api/interviews/${id}`
}

/**
 * @summary Get interview session with questions and answers
 */
export const getInterview = async (id: number, options?: RequestInit): Promise<InterviewSession> => {

  return customFetch<InterviewSession>(getGetInterviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInterviewQueryKey = (id: number,) => {
    return [
    `/api/interviews/${id}`
    ] as const;
    }


export const getGetInterviewQueryOptions = <TData = Awaited<ReturnType<typeof getInterview>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterview>>> = ({ signal }) => getInterview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewQueryResult = NonNullable<Awaited<ReturnType<typeof getInterview>>>
export type GetInterviewQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get interview session with questions and answers
 */

export function useGetInterview<TData = Awaited<ReturnType<typeof getInterview>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitAnswersUrl = (id: number,) => {




  return `/api/interviews/${id}/answers`
}

/**
 * @summary Submit answers to interview questions
 */
export const submitAnswers = async (id: number,
    answersInput: AnswersInput, options?: RequestInit): Promise<InterviewSession> => {

  return customFetch<InterviewSession>(getSubmitAnswersUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(answersInput)
  }
);}





export const getSubmitAnswersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAnswers>>, TError,{id: number;data: BodyType<AnswersInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitAnswers>>, TError,{id: number;data: BodyType<AnswersInput>}, TContext> => {

const mutationKey = ['submitAnswers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAnswers>>, {id: number;data: BodyType<AnswersInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  submitAnswers(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitAnswersMutationResult = NonNullable<Awaited<ReturnType<typeof submitAnswers>>>
    export type SubmitAnswersMutationBody = BodyType<AnswersInput>
    export type SubmitAnswersMutationError = ErrorType<unknown>

    /**
 * @summary Submit answers to interview questions
 */
export const useSubmitAnswers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAnswers>>, TError,{id: number;data: BodyType<AnswersInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitAnswers>>,
        TError,
        {id: number;data: BodyType<AnswersInput>},
        TContext
      > => {
      return useMutation(getSubmitAnswersMutationOptions(options));
    }

export const getEvaluateAnswersUrl = (id: number,) => {




  return `/api/interviews/${id}/evaluate`
}

/**
 * @summary AI evaluation of interview answers
 */
export const evaluateAnswers = async (id: number, options?: RequestInit): Promise<InterviewSession> => {

  return customFetch<InterviewSession>(getEvaluateAnswersUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEvaluateAnswersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateAnswers>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof evaluateAnswers>>, TError,{id: number}, TContext> => {

const mutationKey = ['evaluateAnswers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evaluateAnswers>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  evaluateAnswers(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EvaluateAnswersMutationResult = NonNullable<Awaited<ReturnType<typeof evaluateAnswers>>>

    export type EvaluateAnswersMutationError = ErrorType<unknown>

    /**
 * @summary AI evaluation of interview answers
 */
export const useEvaluateAnswers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateAnswers>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof evaluateAnswers>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getEvaluateAnswersMutationOptions(options));
    }

export const getCreateInterviewEvaluationTaskUrl = (id: number,) => {




  return `/api/interviews/${id}/evaluation/tasks`
}

/**
 * @summary Queue evaluation for the current submitted answers
 */
export const createInterviewEvaluationTask = async (id: number, options?: RequestInit): Promise<AiTaskAccepted> => {

  return customFetch<AiTaskAccepted>(getCreateInterviewEvaluationTaskUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateInterviewEvaluationTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterviewEvaluationTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInterviewEvaluationTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['createInterviewEvaluationTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInterviewEvaluationTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  createInterviewEvaluationTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInterviewEvaluationTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createInterviewEvaluationTask>>>

    export type CreateInterviewEvaluationTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Queue evaluation for the current submitted answers
 */
export const useCreateInterviewEvaluationTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterviewEvaluationTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInterviewEvaluationTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCreateInterviewEvaluationTaskMutationOptions(options));
    }

export const getGetDashboardUrl = () => {




  return `/api/dashboard`
}

/**
 * @summary Get dashboard summary stats
 */
export const getDashboard = async ( options?: RequestInit): Promise<DashboardSummary> => {

  return customFetch<DashboardSummary>(getGetDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardQueryKey = () => {
    return [
    `/api/dashboard`
    ] as const;
    }


export const getGetDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboard>>> = ({ signal }) => getDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboard>>>
export type GetDashboardQueryError = ErrorType<unknown>


/**
 * @summary Get dashboard summary stats
 */

export function useGetDashboard<TData = Awaited<ReturnType<typeof getDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAiTasksUrl = (params?: ListAiTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ai-tasks?${stringifiedParams}` : `/api/ai-tasks`
}

/**
 * @summary List the authenticated user's AI tasks
 */
export const listAiTasks = async (params?: ListAiTasksParams, options?: RequestInit): Promise<AiTaskListResponse> => {

  return customFetch<AiTaskListResponse>(getListAiTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiTasksQueryKey = (params?: ListAiTasksParams,) => {
    return [
    `/api/ai-tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAiTasksQueryOptions = <TData = Awaited<ReturnType<typeof listAiTasks>>, TError = ErrorType<ErrorResponse>>(params?: ListAiTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAiTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiTasks>>> = ({ signal }) => listAiTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAiTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listAiTasks>>>
export type ListAiTasksQueryError = ErrorType<ErrorResponse>


/**
 * @summary List the authenticated user's AI tasks
 */

export function useListAiTasks<TData = Awaited<ReturnType<typeof listAiTasks>>, TError = ErrorType<ErrorResponse>>(
 params?: ListAiTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAiTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAiTasksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAiTaskUrl = (taskId: string,) => {




  return `/api/ai-tasks/${taskId}`
}

/**
 * @summary Get one owned AI task and its validated result projection
 */
export const getAiTask = async (taskId: string, options?: RequestInit): Promise<AiTaskDetail> => {

  return customFetch<AiTaskDetail>(getGetAiTaskUrl(taskId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAiTaskQueryKey = (taskId: string,) => {
    return [
    `/api/ai-tasks/${taskId}`
    ] as const;
    }


export const getGetAiTaskQueryOptions = <TData = Awaited<ReturnType<typeof getAiTask>>, TError = ErrorType<ErrorResponse>>(taskId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAiTask>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiTaskQueryKey(taskId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiTask>>> = ({ signal }) => getAiTask(taskId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiTask>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAiTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getAiTask>>>
export type GetAiTaskQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get one owned AI task and its validated result projection
 */

export function useGetAiTask<TData = Awaited<ReturnType<typeof getAiTask>>, TError = ErrorType<ErrorResponse>>(
 taskId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAiTask>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAiTaskQueryOptions(taskId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMarkAiTaskViewedUrl = (taskId: string,) => {




  return `/api/ai-tasks/${taskId}/viewed`
}

/**
 * @summary Mark a terminal AI task as viewed
 */
export const markAiTaskViewed = async (taskId: string, options?: RequestInit): Promise<AiTaskViewedResponse> => {

  return customFetch<AiTaskViewedResponse>(getMarkAiTaskViewedUrl(taskId),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getMarkAiTaskViewedMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAiTaskViewed>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markAiTaskViewed>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['markAiTaskViewed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAiTaskViewed>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  markAiTaskViewed(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAiTaskViewedMutationResult = NonNullable<Awaited<ReturnType<typeof markAiTaskViewed>>>

    export type MarkAiTaskViewedMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Mark a terminal AI task as viewed
 */
export const useMarkAiTaskViewed = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAiTaskViewed>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markAiTaskViewed>>,
        TError,
        {taskId: string},
        TContext
      > => {
      return useMutation(getMarkAiTaskViewedMutationOptions(options));
    }

export const getListNotificationsUrl = (params?: ListNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notifications?${stringifiedParams}` : `/api/notifications`
}

/**
 * @summary List the authenticated user's notifications
 */
export const listNotifications = async (params?: ListNotificationsParams, options?: RequestInit): Promise<NotificationListResponse> => {

  return customFetch<NotificationListResponse>(getListNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationsQueryKey = (params?: ListNotificationsParams,) => {
    return [
    `/api/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<ErrorResponse>>(params?: ListNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List the authenticated user's notifications
 */

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<ErrorResponse>>(
 params?: ListNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getClaimNotificationToastsUrl = () => {




  return `/api/notifications/toast-claims`
}

/**
 * @summary Atomically claim eligible unread notification toasts
 */
export const claimNotificationToasts = async (toastClaimsInput: ToastClaimsInput, options?: RequestInit): Promise<ToastClaimsResponse> => {

  return customFetch<ToastClaimsResponse>(getClaimNotificationToastsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(toastClaimsInput)
  }
);}





export const getClaimNotificationToastsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimNotificationToasts>>, TError,{data: BodyType<ToastClaimsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof claimNotificationToasts>>, TError,{data: BodyType<ToastClaimsInput>}, TContext> => {

const mutationKey = ['claimNotificationToasts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimNotificationToasts>>, {data: BodyType<ToastClaimsInput>}> = (props) => {
          const {data} = props ?? {};

          return  claimNotificationToasts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClaimNotificationToastsMutationResult = NonNullable<Awaited<ReturnType<typeof claimNotificationToasts>>>
    export type ClaimNotificationToastsMutationBody = BodyType<ToastClaimsInput>
    export type ClaimNotificationToastsMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Atomically claim eligible unread notification toasts
 */
export const useClaimNotificationToasts = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimNotificationToasts>>, TError,{data: BodyType<ToastClaimsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof claimNotificationToasts>>,
        TError,
        {data: BodyType<ToastClaimsInput>},
        TContext
      > => {
      return useMutation(getClaimNotificationToastsMutationOptions(options));
    }

export const getStreamNotificationsUrl = () => {




  return `/api/notifications/stream`
}

/**
 * @summary Stream authenticated notification snapshots
 */
export const streamNotifications = async ( options?: RequestInit): Promise<string> => {

  return customFetch<string>(getStreamNotificationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamNotificationsQueryKey = () => {
    return [
    `/api/notifications/stream`
    ] as const;
    }


export const getStreamNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof streamNotifications>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamNotificationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamNotifications>>> = ({ signal }) => streamNotifications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type StreamNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof streamNotifications>>>
export type StreamNotificationsQueryError = ErrorType<ErrorResponse>


/**
 * @summary Stream authenticated notification snapshots
 */

export function useStreamNotifications<TData = Awaited<ReturnType<typeof streamNotifications>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getStreamNotificationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMarkNotificationReadUrl = (notificationId: string,) => {




  return `/api/notifications/${notificationId}/read`
}

/**
 * @summary Mark one owned notification as read
 */
export const markNotificationRead = async (notificationId: string, options?: RequestInit): Promise<NotificationReadResponse> => {

  return customFetch<NotificationReadResponse>(getMarkNotificationReadUrl(notificationId),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getMarkNotificationReadMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['markNotificationRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationRead>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  markNotificationRead(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationRead>>>

    export type MarkNotificationReadMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Mark one owned notification as read
 */
export const useMarkNotificationRead = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationRead>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getMarkNotificationReadMutationOptions(options));
    }

export const getMarkAllNotificationsReadUrl = () => {




  return `/api/notifications/read-all`
}

/**
 * @summary Mark all owned unread notifications as read
 */
export const markAllNotificationsRead = async ( options?: RequestInit): Promise<NotificationReadAllResponse> => {

  return customFetch<NotificationReadAllResponse>(getMarkAllNotificationsReadUrl(),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getMarkAllNotificationsReadMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,void, TContext> => {

const mutationKey = ['markAllNotificationsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllNotificationsRead>>, void> = () => {


          return  markAllNotificationsRead(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAllNotificationsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllNotificationsRead>>>

    export type MarkAllNotificationsReadMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Mark all owned unread notifications as read
 */
export const useMarkAllNotificationsRead = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markAllNotificationsRead>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMarkAllNotificationsReadMutationOptions(options));
    }

